/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountItemGroupModifierRequestSchema } from "./calculateDiscountItemGroupModifierRequestSchema.ts";

export const calculateDiscountItemGroupUnionModifierRequestSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(calculateDiscountItemGroupModifierRequestSchema),
});
